export default "__VITE_ASSET__B9hh$quO__"